import { Search, X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  'aria-label'?: string;
  className?: string;
}

/**
 * Compact neumorphic search field for the calendar toolbars (monthly / weekly /
 * daily). Matches the inset style of the ámbito/subcontrato selects that sit
 * next to it, with a clear (×) button when there's text. Client-side filtering
 * lives in the parent — this is a controlled input only.
 */
export function SearchInput({
  value,
  onChange,
  placeholder = 'Buscar…',
  'aria-label': ariaLabel = 'Buscar',
  className,
}: SearchInputProps) {
  return (
    <div className={cn('relative', className)}>
      <Search className="pointer-events-none absolute left-2 top-1/2 h-3 w-3 -translate-y-1/2 text-sime-text-tertiary" />
      <input
        type="text"
        value={value}
        onChange={(e) => { onChange(e.target.value); }}
        placeholder={placeholder}
        aria-label={ariaLabel}
        className={cn(
          'w-full rounded-lg bg-transparent py-1 pl-6 pr-6 text-[11px]',
          'shadow-neu-inset-xs text-sime-text-primary placeholder:text-sime-text-tertiary',
          'focus:outline-none focus:ring-1 focus:ring-sime-accent',
        )}
      />
      {value ? (
        <button
          type="button"
          onClick={() => { onChange(''); }}
          aria-label="Limpiar búsqueda"
          className="absolute right-1.5 top-1/2 -translate-y-1/2 text-sime-text-tertiary hover:text-sime-text-primary"
        >
          <X className="h-3 w-3" />
        </button>
      ) : null}
    </div>
  );
}
